define(["dojo-proxy-loader?name=dojo/_base/declare!/home/jenkins/agent/workspace/mailchimp-cd/MC-Mono-Build/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "mojo/page/shouldTrack"], function (declare, shouldTrack) {
  return declare([], {
    constructor: function (params) {
      if (!shouldTrack()) {
        return;
      }
      var script = document.createElement("script");
      script.async = true;
      script.src = params.trackingUrl;
      document.body.appendChild(script);
    }
  });
});